export const FunctionalityCookies = {
  cookiesTable: [
    {
      vendor: 'Workable',
      vendorURL: 'https://www.workable.com/privacy',
      cookies: '_state.IdPclient, hb_wb_sword_af, exitIntentShown, pvc_visits[]'
    },
    {
      vendor: 'Upscope',
      vendorURL: 'https://app.upscope.io/api/contracts/privacy.pdf',
      cookies: '_upscope__region, _upscope__shor, _upscope__shortId'
    },
    {
      vendor: 'Hubspot',
      vendorURL: 'https://legal.hubspot.com/privacy-policy',
      cookies: '__hssc, messagesUtk'
    },
    {
      vendor: 'Cloudfare',
      vendorURL: 'https://www.cloudflare.com/en-gb/privacypolicy/',
      cookies: '__cf_bm, shield-www_client-ec'
    },
    {
      vendor: 'Google',
      vendorURL: 'https://business.safety.google/privacy/',
      cookies: 'custom_ga_data, SIDCC, AMP_TOKEN, G_ENABLED_IDPS'
    },
    {
      vendor: 'Linkedin',
      vendorURL: 'https://www.linkedin.com/legal/privacy-policy',
      cookies: 'lidc, li_gc'
    },
    {
      vendor: 'Heap',
      vendorURL: 'https://www.heap.io/privacy',
      cookies: 'userty.core.p.app_id_hash'
    },
    {
      vendor: 'Pubmatic',
      vendorURL: 'https://pubmatic.com/legal/privacy/',
      cookies: 'PugT'
    },
    {
      vendor: 'Cheq',
      vendorURL: 'https://cheq.ai/privacy-policy/',
      cookies: '_cq_duid, _cq_suid, _cq_session'
    },
    {
      vendor: 'Beamer',
      vendorURL: 'https://www.getbeamer.com/privacy-policy',
      cookies: '_BEAMER_FIRST_VISIT_<id>'
    },
    {
      vendor: 'Salesloft',
      vendorURL: 'https://www.salesloft.com/legal/platform-privacy-notice',
      cookies: 'drift_aid, drift_campaign_refresh'
    }
  ]
};
